import React from 'react';
import { HeroSection } from './components/HeroSection';
import { DiagnosisSection } from './components/DiagnosisSection';
import { CureSection } from './components/CureSection';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <main className="min-h-screen bg-carbon font-sans overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <DiagnosisSection data-id="element-2" />
      <CureSection data-id="element-3" />
      <FinalCTA data-id="element-4" />
    </main>;
}